import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_SOCKET_URL, {
      withCredentials: false,
      transports: ["polling", "websocket"],
      reconnection: true,
      reconnectionAttempts: 3,
      reconnectionDelay: 10000,
      timeout: 20000,
    });
    setSocket(newSocket);

    newSocket.on("connect", () =>
      console.log("Socket connected:", newSocket.id)
    );
    newSocket.on("reconnect", (attemptNumber) => {
      console.log("Reconnecting: attempt:-", attemptNumber)
    })
    newSocket.on("disconnect", () => console.log("Socket disconnected"));

    return () => newSocket.disconnect();
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocket = () => {
  return useContext(SocketContext);
};
